// extracted by mini-css-extract-plugin
export default {"notfound":"_404_notfound__tnS5Z","notfound-404":"_404_notfound-404__mfqMb"};